import React, { useEffect, useState } from "react";
import Admin from "../layout/Admin";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getSatisfaction } from "../../actions/satisfaction";
import { subDays, format } from "date-fns";
import spinner from "../layout/spinner.gif";
import SatisfactionChart from "./SatisfactionChart";
import SatisfactionTable from "./SatisfactionTable";

const Satisfaction = ({ getSatisfaction, satisfaction: { printers, loading } }) => {
  const [formData, setFormData] = useState({
    startDate: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    endDate: format(new Date(), "yyyy-MM-dd"),
  });
  const { startDate, endDate } = formData;

  useEffect(() => {
    getSatisfaction(formData);
    // Only the initial range is loaded automatically; later ranges go through Search
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSatisfaction]);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <Admin>
      <>
        <h2 className="my-6 text-2xl font-semibold text-gray-700 dark:text-gray-200">
          Сэтгэл ханамж
        </h2>
        <div className="mb-8">
          <div className="flex flex-wrap items-center p-4 bg-white rounded-lg shadow-xs dark:bg-gray-800 mb-6">
            <label className="inline-flex items-center ml-6 text-gray-600 dark:text-gray-400">
              <span className="mr-2 text-gray-600 dark:text-gray-400">
                From:
              </span>
              <input
                type="date"
                name="startDate"
                value={startDate}
                onChange={(e) => onChange(e)}
                className="text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md focus:border-purple-500 focus:outline-none"
              ></input>
            </label>
            <label className="inline-flex items-center ml-6 text-gray-600 dark:text-gray-400">
              <span className="mr-2 text-gray-600 dark:text-gray-400">To:</span>
              <input
                type="date"
                name="endDate"
                value={endDate}
                onChange={(e) => onChange(e)}
                className="text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md focus:border-purple-500 focus:outline-none"
              ></input>
            </label>
            <div className="ml-6">
              <button
                className={`px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-purple-600 border border-transparent rounded-lg active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-200 ${
                  loading || !startDate || !endDate
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                disabled={loading || !startDate || !endDate}
                onClick={() => {
                  getSatisfaction(formData);
                }}
              >
                Search
              </button>
            </div>
          </div>
        </div>
        {loading ? (
          <img
            src={spinner}
            className="my-6"
            style={{ width: "50px", margin: "auto", display: "block" }}
            alt="Loading..."
          />
        ) : (
          <>
            <div className="mb-8">
              <SatisfactionChart printerData={printers} />
            </div>
            <div className="mb-8">
              <SatisfactionTable printerData={printers} />
            </div>
          </>
        )}
      </>
    </Admin>
  );
};

Satisfaction.propTypes = {
  getSatisfaction: PropTypes.func.isRequired,
  satisfaction: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  satisfaction: state.satisfaction,
});

export default connect(mapStateToProps, { getSatisfaction })(Satisfaction);
